<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaServiciuPostVanzare')}} </h4>
        </div>
        <form class="add-user-form" id="add-post-service">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_1" :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               v-bind:name="input_field.inputName"
                               v-bind:id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12 col-xs-12 col-lg-12">
                    <button @click.prevent='addPostService()' :disabled="this.$store.state.loading">
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import PostServicesService from '../../api-services/post_services.service.js'
export default {
  name: 'addsubtypes',
  data () {
    return {
      input_fields: {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.post_service) ? this.post_service.ord : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.post_service) ? this.post_service.name : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'value',
            labelName: this.$t('placeholder.valoare'),
            inputValue: (this.post_service) ? this.post_service.value : null,
            icon: 'fas fa-money-bill-wave info-tool'
          }
        ],
        column_2: [
          {
            inputName: 'price',
            labelName: this.$t('placeholder.pret'),
            inputValue: (this.post_service) ? this.post_service.price : null,
            icon: 'fas fa-file-signature'
          }
        ]
      }
    }
  },
  methods: {
    addPostService () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-post-service'))
      PostServicesService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.postServiciuAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push('/post-sale-services')
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('hideLoading')
  }
}
</script>
